import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Card,
    CardContent,
    Avatar,
    Stack,
    Button,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CheckIcon from "@mui/icons-material/Check";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import CategoriesModal from "./CategoryPopUp";

const imgBaseUrl = "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/";
const truncateText = (text = "", max = 25) => {
    if (text.length <= max) return text;
    return text.slice(0, max) + "...";
};

function CategoryItem({ item, selectedId, handleClick, handleCartOpertation }) {
    console.log("item", item);
    const selected = selectedId === item.id;

    return (
        <Stack
            alignItems="center"
            spacing={1}
            sx={{ cursor: "pointer", minWidth: 80 }}
            onClick={(e) => handleClick(e, item.id)}

        >
            <Box position="relative">
                <Avatar
                    sx={{
                        width: 72,
                        height: 72,
                        bgcolor: selected ? "#e6f4ea" : "#f1f3f4",
                        fontSize: 32,
                        border: selected ? "2px solid #2e7d32" : "none",
                        transition: "0.25s",
                    }}
                >
                    {item.image_path ? (
                        <Box
                            component="img"
                            src={`${imgBaseUrl}${item.image_path}`}
                            alt={item.name}
                            sx={{
                                width: 72,
                                height: 72,
                                objectFit: "contain",
                            }}
                        />
                    ) : (
                        item.emoji
                    )}
                </Avatar>

                {selected && (
                    <Avatar
                        sx={{
                            width: 22,
                            height: 22,
                            bgcolor: "#37474f",
                            position: "absolute",
                            bottom: 0,
                            right: 0,
                        }}
                    >
                        <CheckIcon sx={{ fontSize: 14 }} />
                    </Avatar>
                )}
            </Box>
            <Typography fontWeight={500} fontSize={"12px"} textAlign={"center"}>{item.name}</Typography>
        </Stack>
    );
}

function ProductCard({ product, handleCartOpertation, machineId }) {
    console.log("product", product);
    const imageUrl = product?.imageUrl
        ? `https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${product.imageUrl}`
        : `https://daalchini.s3.ap-south-1.amazonaws.com/${product?.imageUrl}`;

    return (
        <Box sx={{ p: 1 }} style={{ paddingLeft: "5px", paddingRight: "2px" }}>
            <Card
                sx={{
                    borderRadius: 4,
                    minWidth: 170,
                    height: 250,              // ✅ FIXED CARD HEIGHT
                    flexShrink: 0,
                    display: "flex",
                    boxShadow: "0 6px 20px rgb(103 92 92 / 12%)",
                    justifyContent: "center",
                }}
            >
                <CardContent
                    sx={{
                        width: "150px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between", // ✅ distribute space evenly
                    }}
                >
                    <Stack spacing={1.2} alignItems="center">
                        {/* IMAGE AREA (FIXED) */}
                        <Box
                            component="img"
                            src={imageUrl}
                            alt={product?.mvName || "product"}
                            loading="lazy"
                            sx={{
                                height: 90,          // ✅ FIXED IMAGE HEIGHT
                                width: "100%",
                                objectFit: "contain",
                            }}
                        />

                        {/* PRODUCT NAME (FIXED HEIGHT) */}
                        <Typography
                            fontWeight={600}
                            textAlign="center"
                            style={{
                                marginLeft: "-20px",
                                marginRight: "-20px",
                            }}
                            sx={{
                                height: 40,          // ✅ FIXED TEXT AREA
                                overflow: "hidden",

                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                            }}
                        >
                            {truncateText(product?.mvName, 15)}
                        </Typography>

                        {/* PRICE */}
                        <Typography color="text.secondary">
                            ₹{product?.mvOfferPrice?.toFixed(2)}
                        </Typography>
                    </Stack>

                    {/* BUTTON ALWAYS AT BOTTOM */}
                    {product.myCount > 0 ?
                        <Button

                            variant="outlined"
                            fullWidth
                            sx={{
                                mt: 1,
                                borderRadius: 3,
                                textTransform: "none",
                                borderColor: "#16a34a",
                                color: "#ffffff",
                                fontWeight: 600,
                                backgroundColor: "#16a34a",
                                display: "flex",
                                justifyContent: "space-between",
                                "&:hover": { backgroundColor: "#16a34a" }
                            }}
                        >
                            <span onClick={(e) => handleCartOpertation(e, product.index, product.slotId, product.myCount, 'remove', machineId)}>-</span> {product.myCount} <span onClick={(e) => handleCartOpertation(e, product.index, product.slotId, product.myCount, 'add', machineId)}>+</span>
                        </Button> : <Button
                            onClick={(e) => {
                                handleCartOpertation(e, product.index, product.slotId, 0, 'add', machineId);


                            }}





                            variant="outlined"
                            fullWidth
                            sx={{
                                mt: 1,
                                borderRadius: 3,
                                textTransform: "none",
                                borderColor: "#16a34a",
                                color: "#16a34a",
                                fontWeight: 600,

                            }}
                        >
                            Add
                        </Button>}
                </CardContent>
            </Card>
        </Box>
    );
}



function MachineCard({ second = false, item, handleCartOpertation,navigate }) {
    const slots = item?.slotDetails || [];

    const gotoMachine = (machineId) => {
        navigate(`items?machineId=${machineId}&value=null&showItems=true`)
    }

    return (
        <Card
            sx={{
                mt: 2,
                borderRadius: 5,
                p: 2,
                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
            }}
        >
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack direction="row" spacing={1.5} alignItems="center">
                    <Avatar variant="rounded">🏪</Avatar>
                    <Box>
                        <Typography fontWeight={700}>{item?.vmName}</Typography>
                        <Typography variant="body2" color="text.secondary">
                            {item?.address}
                        </Typography>
                    </Box>
                </Stack>

                  <Stack alignItems="flex-end">
                    <LocationOnIcon sx={{ color: "gray" }} />
                 <Typography variant="caption" color="text.secondary" textAlign={"center"}>
  {item.distance 
    ? `${(item.distance / 1000).toFixed(3)} Km` 
    : "0.543 Km"}
</Typography>

                </Stack>  
            </Stack>

            {/* PRODUCTS SECTION */}
        
             
<Box
  sx={{
    display: "flex",
    gap: 2,
    mt: 2,
    overflowX: "auto",
    pb: 1,
    "&::-webkit-scrollbar": { display: "none" },
  }}
>
  {slots.length > 0 ? (
    <>
      {slots.slice(0,4).map((p, i) => (
        <ProductCard
          key={i}
          product={p}
          handleCartOpertation={handleCartOpertation}
          machineId={item?.vmId}
        />
      ))}

      <Button
        size="small"
        variant="outlined"
        onClick={() => gotoMachine(item?.vmId)}
        style={{color:"#718198"}}
        sx={{
          whiteSpace: "nowrap",
          flexShrink: 0,
          minWidth: 110,
          alignSelf: "center",
          //color: "#384F6F",
          borderColor: "#384F6F1F",
          height: 42,
          borderRadius: 2,
        }}
      >
       
        View all
        <div style={{ marginLeft: "5px",backgroundColor:"#384F6F1F",borderRadius:"50%",width:"22px",height:"22px",display:"flex",alignItems:"center",justifyContent:"center" }}>
         <ArrowForwardIcon fontSize="small" />
         </div>
      </Button>
    </>
  ) : (
    // ⭐ center button when no products
    <Box sx={{ width: "100%", textAlign: "center" }}>
      <Button
        size="small"
        variant="outlined"
        onClick={() => gotoMachine(item?.vmId)}
        endIcon={<ArrowForwardIcon fontSize="small" />}
        sx={{
          minWidth: 140,
        }}
         style={{color:"#718198"}}
      >
        View all
      </Button>
    </Box>
  )}
</Box>


        </Card>
    );
}

export default function VendingUI({
  categories,
  fetchCategoriesWise,
  categoriesWiseVmItems,
  setCategoriesWiseVmItems,
  handleCartOpertation,
  setViewall,
  viewall,
}) {
  const [selectedId, setSelectedId] = useState(null);
  const navigate = useNavigate();

  // ✅ scroll ref
  const scrollRef = React.useRef(null);

  // ✅ Move selected category to first
  const sortedCategories = React.useMemo(() => {
    if (!selectedId) return categories;

    const selected = categories.find((c) => c.id === selectedId);
    const rest = categories.filter((c) => c.id !== selectedId);

    return selected ? [selected, ...rest] : categories;
  }, [categories, selectedId]);

  // ✅ auto scroll left when selecting category
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ left: 0, behavior: "smooth" });
    }
  }, [selectedId]);

  const handleClick = (e, item_id) => {
    if (selectedId === item_id) {
      setSelectedId(null);
      setCategoriesWiseVmItems([]);
    } else {
      fetchCategoriesWise(item_id);
      setSelectedId(item_id);
    }
  };

  return (
    <>
      {/* MODAL */}
      <CategoriesModal
        setViewall={setViewall}
        viewall={viewall}
        categories={categories}
        setCategoriesWiseVmItems={setCategoriesWiseVmItems}
        fetchCategoriesWise={fetchCategoriesWise}
        setSelectedId={setSelectedId}
        selectedId={selectedId}
      />

      <Box sx={{ overflowY: "auto" }}>
        {/* HEADER */}
        <Stack
          direction="row"
          justifyContent="space-between"
          mb={1}
          sx={{ pt: 2, px: 1.5 }}
        >
          <Typography variant="h6" fontWeight={500} style={{color:"#333F4E"}}>
            Categories
          </Typography>

          <Typography
            color="primary"
            fontWeight={500}
            sx={{ cursor: "pointer" }}
            onClick={() => setViewall(true)}
             style={{color:"#718198"}}
          >
            View all
          </Typography>
        </Stack>

        {/* CATEGORY SCROLL */}
        <Box
          ref={scrollRef}
          sx={{
            display: "flex",
            gap: 2,
            overflowX: "auto",
            px: 1,
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {sortedCategories.map((cat) => (
            <CategoryItem
              key={cat.id}
              item={cat}
              selectedId={selectedId}
              handleClick={handleClick}
            />
          ))}
        </Box>

        {/* PRODUCTS */}
        {selectedId !== null && (
          <>
            {categoriesWiseVmItems.length > 0 ? (
              <Box mt={2}>
                {categoriesWiseVmItems.map((item, index) => (
                  <MachineCard
                    key={index}
                    second={index > 0}
                    item={item}
                    handleCartOpertation={handleCartOpertation}
                    navigate={navigate}
                  />
                ))}
              </Box>
            ) : (
              <Box
                sx={{
                  border: "1px solid #d6d6d6",
                  borderRadius: "10px",
                  px: 2,
                  py: 2,
                  backgroundColor: "#f9fafb",
                  minWidth: "320px",
                  textAlign: "center",
                  mt: 2,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: "#3b4a5a",
                    fontSize: "12px",
                  }}
                >
                  No Product Found In This Category In Your Area
                </Typography>
              </Box>
            )}
          </>
        )}
      </Box>
    </>
  );
}
